import { Injectable, inject } from '@angular/core';
import { CanActivate } from '@angular/router';
import { combineLatest } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { MultilanguageService } from './multilanguage.service';

@Injectable({ providedIn: 'root' })
export class MultilanguageGuard implements CanActivate {
  private readonly multilanguageService = inject(MultilanguageService);

  canActivate() {
    return this.validate();
  }

  private validate() {
    return combineLatest([
      this.multilanguageService.languages$,
      this.multilanguageService.currentLanguage$,
      this.multilanguageService.preferredLanguage$,
    ]).pipe(
      map(() => true),
      take(1),
    );
  }
}
